<template>
  <div class="course flex">
    <div v-for="(course, i) in $props.courses" :key="`course-${i}`" class="course-container flex">
      <div v-if="course.href && course.name" class="course-container-title text-center">
        <a
          v-if="course.href"
          :href="course.href"
          class="general-anchor decorated"
          target="_blank"
          rel="noreferrer,noopener"
        >
          <h2>
            <span>{{ course.name }}</span>
          </h2>
        </a>
        <h2 v-else>{{ course.name }}</h2>
      </div>
      <div class="course-container-data flex">
        <div v-if="course.logotype" class="course-container-data-image flex">
          <div
            :class="[
              'course-container-data-image-container flex',
              { [course.backgroundColor]: course.backgroundColor }
            ]"
          >
            <img
              :src="course.logotype"
              :alt="$t('aboutMe.altLabel', { element: course.site })"
              class="course-container-data-image-container-tag"
            />
          </div>
        </div>
        <div class="course-container-data-title text-center text-sm-left">
          <div v-if="course.site" class="course-container-data-title-text">
            <h3 class="course-container-data-title-text-tag">{{ course.site }}</h3>
          </div>
          <div v-if="course.date" class="course-data-title-text">
            <h3 class="course-container-data-title-text-tag">{{ course.date }}</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Course",
  props: {
    /*
     * @property - courses
     * Array of courses. Defines all content inside this component
     * $course[i].name
     * $course[i].href
     * $course[i].site
     * $course[i].logotype
     * $course[i].backgroundColor
     * $course[i].date
     */
    courses: {
      type: Array,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.course {
  border-top: 0.0625rem solid $main-green;
  flex-wrap: wrap;
  padding: 1.5rem 0 3rem 0;

  &-container {
    flex: 1 0 100%;
    flex-wrap: inherit;
    margin-top: 1.5rem;

    @include breakpoint($large) {
      flex: 1 0 50%;
    }

    &-title {
      padding: 0 0.5rem;
      width: 100%;
    }

    &-data {
      flex-wrap: inherit;
      padding: 0 1rem;
      width: 100%;

      &-image {
        width: 100%;

        @include breakpoint($small) {
          flex: 0 0;
        }

        &-container {
          @include boxShadow(0.25, true, false);
          background-color: $white-raw;
          border: 0.0625rem solid $main-blue;
          border-radius: 0.45rem;
          height: 6.5rem;
          margin: auto;
          overflow: hidden;
          width: 6.5rem;

          &.black {
            background-color: $dark-gray;
            border: 0.0625rem solid $main-green;
          }

          &-tag {
            margin: auto;
            max-height: 95%;
            max-width: 95%;
          }
        }
      }

      &-title {
        width: 100%;

        @include breakpoint($small) {
          flex: 1 0;
          max-width: 100%;
          padding-left: 1rem;
        }

        &-text {
          width: 100%;

          &-tag {
            display: inline-block;
            margin: 0.75rem 0 0.25rem 0;

            @include breakpoint($small) {
              margin: 0.85rem 0 0 0;
            }
          }
        }
      }
    }
  }
}
</style>
